import React from 'react'
import './HeroImg.css'
import IntroImg from '../../resources/assets/home.jpg'
import { Link } from 'react-router-dom'

const HeroImg = () => {
  return (
    <div className='hero'>
        <div className='mask'>
            <img className='into-img' src={IntroImg} alt='homepage'/>
        </div>
        <div className='content'>
            <p>HI, I'M A FREELANCER</p>
            <h1>Software Developer</h1>
            <div>
                <Link to="/project" className='btn'>Project</Link>
                <Link to="/contact" className='btn btn-light'>Contact</Link>
            </div>
        </div>
    </div>
  )
}

export default HeroImg